module.exports = __webpack_public_path__ + "static/media/heart-dark.4e093972.svg";